module.exports = __webpack_public_path__ + "img/red_052.a036b81e.png";